<script setup lang="ts">
defineShortcuts({
  'G-D': () => {
    navigateTo('/')
  },
})
</script>

<template>
  <UDashboardGroup class="bg-muted" storage="local" unit="rem">
    <UDashboardSidebar
      class="border-default bg-default"
      :default-size="18"
      :min-size="18"
      :ui="{ footer: 'border-t border-default' }"
      collapsible
      resizable
    >
      <template #toggle>
        <UDashboardSidebarToggle variant="subtle" />
      </template>
      <template #header="{ collapsed }">
        <div class="flex flex-1 items-center gap-2">
          <UButton
            to="/"
            icon="i-ph-caret-left"
            label="Back to app"
            variant="ghost"
          />
          <div class="flex-1" />
        </div>
      </template>
    </UDashboardSidebar>

    <div class="w-full overflow-auto" data-scroll-root>
      <UDashboardNavbar class="visible lg:hidden" />
      <slot />
    </div>
  </UDashboardGroup>
</template>
